import React, { useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import CloseIcon from "./assets/CloseIcon.svg";
import RanusLogo from "./assets/RanusLogo.svg";
import DiscountIconRed from "./assets/DiscountIconRed.svg";
import DiscountIconOrange from "./assets/DiscountIconOrange.svg";
import SideModal from "../based/SideModal";
import FinanceServices from "../based/services/FinanceServices";
import { STATUS_TRANSACTION } from "../based/Constants";
import Common from "../based/Common";

function FinanceOrderDetail({ show, onClose, orderId }) {
    const refModal = useRef();
    const [model, setModel] = useState(null);

    console.log("model", model);

    //click outside to close
    useEffect(() => {
        const handleOutside = (e) => {
            if (refModal.current && !refModal.current.contains(e.target)) {
                // close modal
                onClose();
            }
        };
        window.addEventListener("click", handleOutside);
        return () => {
            window.removeEventListener("click", handleOutside);
        };
    }, []);

    useEffect(() => {
        if (show) {
            getModel(orderId);
        }
    }, [orderId]);

    const getModel = async (orderId) => {
        const [err, data] = await FinanceServices.GetCreatorLoyaltyOrderModelAsync(orderId);
        if (!err && data) {
            setModel(data);
        } else {
            setModel(null);
        }
    };

    const badgeClass = useMemo(() => {
        let clBadge = `badge-custom`;
        if (!model) return clBadge;
        if (model.status == STATUS_TRANSACTION.SUCCEED) clBadge = `badge-success`;
        else if (model.status == STATUS_TRANSACTION.RETURNED_TO_SENDER) clBadge = `badge-danger`;
        return clBadge;
    }, [model]);

    if (!model) return "";
    return (
        <SideModal show={show} onClose={onClose}>
            <Wrapper>
                <section className="header">
                    <h5>Chi tiết thanh toán</h5>
                    <div className="right-action">
                        <span className={`badge ${badgeClass}`}>Đang giao hàng</span>
                        <button
                            className="btn-close"
                            onClick={(e) => {
                                e.stopPropagation();
                                onClose();
                            }}
                        >
                            <img src={CloseIcon} alt="Close" />
                        </button>
                    </div>
                </section>
                <section className="body">
                    <div className="lst-logo">
                        <div className="ranus-logo">
                            <img src={RanusLogo} alt="Ranus Logo" />
                        </div>
                        <div className="partner-name">
                            <span>{model.displayName}</span>
                        </div>
                    </div>
                    <div className="lst-detail-action">
                        <div className="order-number">
                            <label htmlFor="order-number">Mã đơn hàng</label>
                            <a href="" className="txt">
                                {model.orderNumber} <i className="fa" />
                            </a>
                        </div>
                        <div className="created-date">
                            <label htmlFor="created-date">Ngày tạo</label>
                            <span className="txt">{Common.formatDate(new Date(model.createdDate))} </span>
                        </div>
                        <div className="deliver-date">
                            <label htmlFor="deliver-date">Ngày giao hàng</label>
                            <span className="txt">{Common.formatDate(new Date(model.promisedShippingTime))} </span>
                        </div>
                    </div>
                    <div className="box-order-detail">
                        <div className="box-header">
                            <h6>Chi tiết lợi nhuận</h6>
                            <span className="header-right">{model.paymentMethodName}</span>
                        </div>
                        <div className="box-customer-detail">
                            <div className="box-row">
                                <div className="box-row-left strong">Khách hàng thanh toán</div>
                                <div className="box-row-right strong">
                                    <span>
                                        {Common.formatCurrency(model.finallyPrice)}
                                        {/*  */}
                                    </span>
                                </div>
                            </div>
                            <div className="box-row">
                                <div className="box-row-left">
                                    Tổng đơn hàng trước giảm giá
                                    {/* <div className="discount-badge">
                                        <img src={DiscountIconOrange} alt="" />
                                        <span>Partner</span>
                                    </div> */}
                                </div>
                                <div className="box-row-right">
                                    <span>{Common.formatCurrency(model.totalPrice)}</span>
                                </div>
                            </div>

                            <div className="box-row">
                                <div className="box-row-left">
                                    Tổng giảm giá theo voucher
                                    <div className="discount-badge">
                                        <img src={DiscountIconOrange} alt="" />
                                        <span>Ranus</span>
                                    </div>
                                </div>
                                <div className="box-row-right">
                                    <span>{Common.formatCurrency(model.totalDiscount)}</span>
                                </div>
                            </div>
                            <div className="box-row">
                                <div className="box-row-left">
                                    Tổng giảm giá theo chiến dịch
                                    <div className="discount-badge">
                                        <img src={DiscountIconOrange} alt="" />
                                        <span>Ranus</span>
                                    </div>
                                </div>
                                <div className="box-row-right">
                                    <span>{Common.formatCurrency(model.totalCampaign)}</span>
                                </div>
                            </div>
                        </div>

                        <div className="box-vat-detail">
                            <div className="box-row">
                                <div className="box-row-left strong">Chi phí VAT 8%</div>
                                <div className="box-row-right strong">
                                    <span>
                                        -{Common.formatCurrency(model.totalVATCost)}
                                        {/*  */}
                                    </span>
                                </div>
                            </div>
                            {/* <div className="box-row">
                                <div className="box-row-left">Thuế giá trị gia tăng</div>
                                <div className="box-row-right">
                                    <div className="first-box">
                                        <span>-1.450.000đ</span>
                                    </div>
                                    <div className="second-box">
                                        <span>x8%</span>
                                    </div>
                                    <div className="third-box">
                                        <span>-66.750đ</span>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                        <div className="box-product-detail">
                            <div className="box-row">
                                <div className="box-row-left strong">Chi phí sản xuất Ranus</div>
                                <div className="box-row-right strong">
                                    <span>-{Common.formatCurrency(model.totalProduction)}</span>
                                </div>
                            </div>
                            {model.creatorOrderProducts &&
                                model.creatorOrderProducts.map((item, index) => {
                                    return (
                                        <div className="box-product" key={index}>
                                            <div className="box-product-left">
                                                <div className="product-img">{item.productAvatar && <img src={item.productAvatar} alt="" />}</div>
                                            </div>
                                            <div className="box-product-right">
                                                <div className="box-product-name">
                                                    <span>{item.productTitle}</span>
                                                </div>
                                                <div className="product-row">
                                                    <div className="product-row-first">
                                                        <span>{item.appProductName}</span>
                                                    </div>
                                                    <div className="product-row-second">
                                                        <span>-{Common.formatCurrency(item.partnerCost + item.printCost + item.packageCost)}</span>
                                                    </div>
                                                    <div className="product-row-third">
                                                        <span>x{item.quantity}</span>
                                                    </div>
                                                    <div className="product-row-fourth">
                                                        <span>-{Common.formatCurrency((item.partnerCost + item.printCost + item.packageCost) * item.quantity)}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>

                        <div className="box-shipping-detail">
                            <div className="box-row">
                                <div className="box-row-left strong">Chi phí vận chuyển</div>
                                <div className="box-row-right strong">
                                    <span>-{Common.formatCurrency(model.totalShippingFee)}</span>
                                </div>
                            </div>
                        </div>

                        <div className="box-final-detail">
                            <div className="box-row">
                                <div className="box-row-left strong">Tiền bản quyền</div>
                                <div className="box-row-right strong">
                                    <span>{Common.formatCurrency(model.totalLoyalty)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Wrapper>
        </SideModal>
    );
}

export default FinanceOrderDetail;

const Wrapper = styled.div`
    .box-product {
        margin: 10px 0;
    }

    .order-number-detail {
        width: 200px;
    }

    section.header {
        display: flex;
        padding: 22px 30px;
        align-items: center;
        border: 1px solid #f3f3f3;
        background: #fff;
    }

    .right-action {
        margin-left: auto;
    }

    section.header h5 {
        color: #303030;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    span.badge.badge-danger {
        border-radius: 20px;
        background: #ffe4e4;
        color: #d70000;
        text-align: right;
        font-family: Lexend;
        font-size: 13px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        padding: 5px 10px;
    }

    button.btn-close {
        border: none;
        background: no-repeat;
        margin: 0 0 0 24px;
    }

    section.body {
        padding: 0 30px;
    }

    .lst-logo {
        display: flex;
        align-items: center;
        margin: 12px 0;
    }

    .partner-name {
        margin-left: 30px;
    }

    .lst-detail-action {
        display: flex;
        justify-content: space-between;
        margin: 12px 0;
    }

    .order-number {
        display: flex;
        flex-direction: column;
    }

    .created-date {
        display: flex;
        flex-direction: column;
    }

    .deliver-date {
        display: flex;
        flex-direction: column;
    }

    .lst-detail-action label {
        overflow: hidden;
        color: #a0a0a0;
        text-overflow: ellipsis;
        font-family: Lexend;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 6px 0;
    }

    .order-number a {
        overflow: hidden;
        color: #2673dd;
        text-overflow: ellipsis;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .lst-detail-action span {
        overflow: hidden;
        color: #303030;
        text-overflow: ellipsis;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .box-order-detail {
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #fff;
        overflow: hidden;
    }

    .box-header {
        padding: 12px 16px;
        display: flex;
        align-items: center;
        border: 1px solid #e5e5e5;
    }

    .box-header h6 {
    }

    .box-header h6 {
        color: #303030;
        font-family: Lexend;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    span.header-right {
    }

    span.header-right {
        margin-left: auto;
        color: #303030;
        text-align: right;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .box-row {
        display: flex;
        align-items: center;
        margin: 6px 0;
    }

    .box-row-left {
        overflow: hidden;
        color: #707070;
        text-overflow: ellipsis;
        font-family: Lexend;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .box-customer-detail {
        padding: 12px 16px;
        border: 1px solid #e5e5e5;
    }

    .box-row-right {
        margin-left: auto;
        display: flex;
        align-items: center;
    }

    .strong {
        color: #303030;
        text-align: right;
        font-family: Lexend;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .box-row-left {
        display: flex;
        align-items: center;
    }

    .discount-badge {
        border-radius: 4px;
        background: #fff5ec;
        padding: 2px 4px;
        display: flex;
        align-items: center;
        margin-left: 6px;
    }

    .discount-badge span {
        color: #ff9027;
        font-family: Lexend;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        letter-spacing: -0.13px;
    }

    .box-vat-detail {
        padding: 12px 16px;
        border: 1px solid #e5e5e5;
    }

    .box-product-detail {
        padding: 12px 16px;
        border: 1px solid #e5e5e5;
    }

    .box-shipping-detail {
        padding: 12px 16px;
        border: 1px solid #e5e5e5;
    }

    .box-final-detail {
        padding: 12px 16px;
        border: 1px solid #e5e5e5;
    }

    .first-box {
        margin-left: 0 12px;
    }

    .second-box {
        margin-left: 24px;
    }

    .third-box {
        margin-left: 24px;
    }

    .product-img {
        width: 88px;
        height: 88px;
    }

    .product-img img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .box-product {
        border-radius: 8px;
        background: #fff5ec;
        padding: 10px 8px;
        display: flex;
        align-items: center;
    }

    .box-product-right {
        flex: 1;
    }

    .product-row {
        display: flex;
        justify-content: space-between;
        margin: 4px 0;
    }

    .box-product-name {
        overflow: hidden;
        color: #303030;
        text-overflow: ellipsis;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .box-final-detail .box-row-right {
        color: #ff9027;
        text-align: right;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
`;
